import React from "react";

interface FlagsServiceProviderProps {
  children: React.ReactElement;
}

export const FlagsServiceProvider = ({ children }: FlagsServiceProviderProps) =>
  children;
